interface CircleLoadingProps {
	className?: string;
	strokeColor?: string; // Añadimos strokeColor como propiedad opcional
}

export const CircleLoading2 = ({
	className = "w-6 h-6", // Tamaño por defecto
	strokeColor = "#ffffff", // Color predeterminado (blanco)
}: CircleLoadingProps) => {
	return (
		<svg
			className={`${className}`}
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 100 100"
			preserveAspectRatio="xMidYMid"
			style={{ shapeRendering: "auto", display: "block", background: "transparent" }}
		>
			<g>
				<circle
					strokeLinecap="round"
					fill="none"
					strokeDasharray="50.26548245743669 50.26548245743669"
					stroke={strokeColor} // Usamos strokeColor aquí
					strokeWidth="4"
					r="32"
					cy="50"
					cx="50"
				>
					<animateTransform
						values="0 50 50;360 50 50"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
						type="rotate"
						attributeName="transform"
					/>
				</circle>
			</g>
		</svg>
	);
};
